const logotext = "RIDWAN";
const meta = {
    title: "Ridwanul Hasan",
    description: "Senior Software Engineer & Software Architect — event-driven systems, growth platforms, and monetization.",
};

const introdata = {
    title: "I’m Ridwanul Hasan",
    animated: {
        first: "I architect event-driven systems",
        second: "I scale growth & monetization",
        third: "I build highly scalable & low maintainance solutions",
    },
    description: "Senior Software Engineer and Software Architect focused on reliable, data-driven products: event-driven backends, global payments, and AI-infused user journeys.",
    your_img_url: "https://pub-cdcdb4b991fe43d595cd132bf162cdda.r2.dev/portrait_dark_background_ready_v2.webp",
};

const dataabout = {
    title: "a bit about myself",
    aboutme: "I design and build scalable web platforms with TypeScript/Node.js, React/Next.js (App Router), and Cloudflare Workers. My work centers on onboarding, activation, retention, and revenue—backed by solid observability and fault tolerance. Recently, I've been leading Commit Push Pray with products like TrendzMart (multivendor e-commerce) and Verbira (SMB CRM), integrating payments, usage-based billing, and lifecycle automation.",
};

const worktimeline = [
  {
    jobtitle: "Senior Software Engineer",
    where: "Ontik Technology",
    date: "Jan 2024 – Present",
  },
  {
    jobtitle: "Software Engineer III (Team Lead)",
    where: "Techzu Ichinode",
    date: "May 2022 – Jan 2024",
  },
  {
    jobtitle: "Independent Consulting & Upskilling",
    where: "Self-employed",
    date: "Oct 2021 – Apr 2022",
  },
  {
    jobtitle: "Software Engineer",
    where: "Fronture Technologies",
    date: "Aug 2019 – Sep 2021",
  },
  {
    jobtitle: "Software Engineer",
    where: "Data Head Pvt. Ltd.",
    date: "Nov 2016 – Jul 2019",
  },
];


const skills = [
    { name: "Node.js", value: 95 },
    { name: "TypeScript", value: 92 },
    { name: "React / Next.js (App Router)", value: 88 },
    { name: "Cloudflare Workers/Pages", value: 88 },
    { name: "AWS (ECS, Lambda, SQS/SNS)", value: 85 },
    { name: "Event-Driven Architecture", value: 90 },
    { name: "Payments (Stripe/Razorpay/Adyen)", value: 84 },
    { name: "Postgres / D1 (SQLite) / R2", value: 82 },
    { name: "Observability (OpenTelemetry)", value: 80 },
    { name: "Hono APIs", value: 86 },
];

const services = [
    {
        title: "Growth Architecture",
        description: "Onboarding, activation, retention, and paywall/packaging systems powered by event streams and rapid experimentation.",
    },
    {
        title: "Payments & Monetization",
        description: "Subscriptions, usage-based billing, regional pricing, tax/compliance, and multi-PSP integrations (Stripe, Razorpay, Adyen, Chargebee).",
    },
    {
        title: "Microservices & APIs",
        description: "Service boundaries, idempotent webhooks, resilient messaging, and clean REST/edge APIs with Hono on Cloudflare Workers.",
    },
    {
        title: "AI-Powered Personalization",
        description: "LLM-assisted onboarding, recommendations, and lifecycle automation with safe fallbacks and experiment guardrails.",
    },
    {
        title: "Frontend Platforms",
        description: "Modern React/Next.js App Router, parallax-friendly UI, and performant rendering with edge caching.",
    },
    {
        title: "Observability & Reliability",
        description: "SLOs, tracing, metrics, and chaos testing to keep distributed systems fast and fault tolerant.",
    },
];

const dataportfolio = [
    {
        img: "https://plus.unsplash.com/premium_photo-1714265042803-aff28fb85d2f?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1170",
        description: "ApplyGoal - University Admission System",
        link: "https://applygoal.com/",
    },
    {
        img: "https://images.unsplash.com/photo-1527430253228-e93688616381",
        description: "Team Liquid, on the famous eSports organization.",
        link: "https://teamliquid.com/",
    },
    {
        img: "https://images.unsplash.com/photo-1518779578993-ec3579fee39f",
        description: "Paul's Cafe, Singapore. One of the best cafe and bakery in singapore, which also has online ordering system for their gourmet menu.",
        link: "https://www.paul-singapore.com/",
    },
    {
        img: "https://images.unsplash.com/photo-1567117439408-c01fa6282ed1?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1171",
        description: "HomeRun: Real Estate Prediction Game",
        link: "https://homerun.estate/",
    },
    {
        img: "https://images.unsplash.com/photo-1635840420670-5470266ffa39?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1169",
        description: "Paypool: Smart Fintech",
        link: "https://paypool.app/",
    },
    {
        img: "https://plus.unsplash.com/premium_photo-1714618849685-89cad85746b1?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1288",
        description: "Drone Dash, Platform for professionals who use drone to get the tasks done.",
        link: "https://www.dronedash.one/",
    },
];

const contactConfig = {
    YOUR_EMAIL: "ridwanshuvro461@gmail.com",
    YOUR_FONE: "(+880) 1763 873 729",
    description: "Interested in architecting growth systems, payments, or SaaS products? I’m available for senior engineering and architecture engagements.",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com/shiro873",
    facebook: "https://www.facebook.com/ridwan.shuvro/",
    linkedin: "https://www.linkedin.com/in/ridwanul-hasan/",
    twitter: "https://x.com/shiro873",
};

export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
